import Vue from 'vue'

const resource = 'pharmacies'

const getByPharmacyId = (params = {}, id) => Vue.axios(`${resource}/${id}/calendars`, {params})
const savePharmacyCalendar = (data, id) => Vue.axios.post(`${resource}/${id}/calendars`, data)
const bulkCopyPharmacyCalendar = (data, id) => Vue.axios.post(`${resource}/${id}/calendars/bulkcopy`, data)
const deletePharmacyCalendar = (params = {}, pharmacyId) => Vue.axios.delete(`${resource}/${pharmacyId}/calendars`, {params})
export default {
  getByPharmacyId,
  savePharmacyCalendar,
  bulkCopyPharmacyCalendar,
  deletePharmacyCalendar
}



// WEBPACK FOOTER //
// ./src/api/calendar.js